import { createSlice } from "@reduxjs/toolkit";
import { reducerPaths } from "../../app/reducerPaths";

const initialState = {
  open: false,
  title: "",
  message: "",
  onOk: () => {},
  onClose: () => {},
  avoidCloseOnOK: false,
  isLoading: false,
  okLabel: "Ok",
  closeLabel: "Close",
  styles: {},
  isDangerouslySetHtml: true
};

const alertDialog = createSlice({
  name: reducerPaths.alertDialog,
  initialState,
  reducers: {
    setAlertDialog: (state, action) => {
      state.open = action.payload?.open;
      state.title = action.payload?.title;
      state.message = action.payload?.message;
      state.onOk = action.payload?.onOk;
      state.avoidCloseOnOK = action?.payload?.avoidCloseOnOK;
      state.okLabel = action.payload?.okLabel || "Ok";
      state.onClose = action.payload?.onClose;
      state.closeLabel = action.payload?.closeLabel || "Close";
      state.styles = action?.payload?.styles || {};
      state.isDangerouslySetHtml = action?.payload?.isDangerouslySetHtml === true || action?.payload?.isDangerouslySetHtml === false ? 
        action?.payload?.isDangerouslySetHtml : true;
    },
    editAlertDialog: (state, action) => {
      for (let i = 0; i < Object.entries(action?.payload)?.length; i++) {
        state[Object.entries(action?.payload)?.[i]?.[0]] = Object.entries(action?.payload)?.[i]?.[1];
      }
    },
    closeAlertDialog: (state, action) => {
      state.open = false;
    },
    resetAlertDialog: () => {
      return initialState;
    }
  },
});

export const { setAlertDialog, editAlertDialog, closeAlertDialog, resetAlertDialog } = alertDialog.actions;

export default alertDialog.reducer;
